import { Input, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import { useState } from "react";
import { importExternalTicketByExternalId } from "../../utils/helpers/ticketHelpers";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../interfaces/users";
import { toast } from "react-toastify";
import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from "react-query";
import {
  ModulePermission,
  userHasPermission,
} from "../../utils/helpers/userHelpers";
import { getTypeTitle } from "../../utils";

interface ImportTicketModalProps {
  type: "checklist" | "measuring" | "assemble";
  onClose: () => void;
  isOpen: boolean;
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
  ) => Promise<QueryObserverResult<any, unknown>>;
}

export const ImportTicketModal = ({
  type,
  onClose,
  isOpen,
  refetch,
}: ImportTicketModalProps) => {
  const [externalId, setExternalId] = useState("");
  const [osNumber, setOsNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const { token, user } = useSelector((state: AuthenticationState) => state);

  const handleClose = () => {
    setExternalId("");
    onClose();
    setLoading(false);
  };

  const handleSubmit = async () => {
    // if (
    //   (type !== "assemble" &&
    //     !userHasPermission(user, {
    //       checklist: ModulePermission.ADMIN,
    //       measuring: ModulePermission.ADMIN,
    //     })) ||
    //   !(type === "assemble" &&
    //     (userHasPermission(user, { assemble: ModulePermission.USER }) || userHasPermission(user, { assemble: ModulePermission.ADMIN })))
    // ) {
    //   return toast.error("Usuário sem permissão para esta funcionalidade");
    // }
    setLoading(true);

    const value = type === "assemble" ? osNumber : externalId;

    if (!value) return toast.error("O campo é obrigatório");
    await importExternalTicketByExternalId(token, value, type, handleClose);

    refetch();
    setExternalId("");
    setLoading(false);
  };
  return (
    <Modal
      open={isOpen}
      confirmLoading={loading}
      onCancel={handleClose}
      onOk={handleSubmit}
    >
      <Content>
        <h2>Importar ticket de {getTypeTitle(type)}</h2>
        {type !== "assemble" ? (
          <>
            <label className="text-base text-[#8C8C8C]">
              ID do ticket<span className="text-red-600">*</span>:
            </label>
            <Input
              onChange={(e) => setExternalId(e.target.value)}
              value={externalId}
              className="mb-2"
            />
          </>
        ) : (
          <>
            <label className="text-base text-[#8C8C8C]">
              Numero da O.S.<span className="text-red-600">*</span>:
            </label>
            <Input
              onChange={(e) => setOsNumber(e.target.value)}
              value={osNumber}
              className="mb-2"
            />
          </>
        )}
      </Content>
    </Modal>
  );
};
